import { IAnalyticSdr } from '../../../types/analyticsSdr';

/**
 * Analytics SDR for Organizations Domain.
 * This information should match the values in the SDR Excel file referenced here:
 * https://chalk.charter.com/display/ERSPM/FE+Analytics
 */

const siteSection = 'Organizations';
const backToOrg = 'Back to Organization';
const editOrgDetails = 'Edit Organization Details';

export const orgsAnalytics: IAnalyticSdr = {
  organizations: {
    siteSection,
    buttonClicks: {
      addOrganizationBtn: {
        itemClicked: 'Add New Organization',
      },
      filterCancelBtn: {
        itemClicked: 'Cancel',
      },
      filterViewResultsBtn: {
        itemClicked: 'View Results',
      },
      filterClearFiltersBtn: {
        itemClicked: 'Clear Filters',
      },
      filterCloseDrawerBtn: {
        itemClicked: 'Close Drawer',
      },
      dismissServiceChipBtn: {
        itemClicked: 'Dismiss Service Chip',
      },
      dismissSourceSystemChipBtn: {
        itemClicked: 'Dismiss Source System Chip',
      },
    },
    menuSelections: {
      sourceSystemsMenu: {
        itemClicked: 'Source Systems',
      },
      servicesMenu: {
        itemClicked: 'Services',
      },
    },
  },

  orgCreate: {
    siteSection,
    siteSubSection: 'Create Organization',
    buttonClicks: {
      backBtn: {
        itemClicked: 'Back',
      },
      seeFeaturesBtn: {
        itemClicked: 'See Features',
      },
      addContactBtn: {
        itemClicked: 'Add Contact',
      },
      removeContactBtn: {
        itemClicked: 'Remove Contact',
      },
      sourceSystemListBtn: {
        itemClicked: 'Source System List',
      },
      removeSourceSystemBtn: {
        itemClicked: 'Remove System',
      },
      addAnotherSystemBtn: {
        itemClicked: 'Add Another System',
      },
      addStorageAccountBtn: {
        itemClicked: 'Add Storage Account',
      },
      removeServiceBtn: {
        itemClicked: 'Remove Service',
      },
      cancelBtn: {
        itemClicked: 'Cancel',
      },
      continueBtn: {
        itemClicked: 'Continue',
      },
    },
    menuSelections: {
      orgTypeMenu: {
        itemClicked: 'Organization Type',
      },
      servicesMenu: {
        itemClicked: 'Services',
      },
      parentOrgMenu: {
        itemClicked: 'Parent Organization',
      },
      contactTypeMenu: {
        itemClicked: 'Contact Type',
      },
      sourceSystemMenu: {
        itemClicked: 'Source System',
      },
    },
  },

  orgFeatureMgmt: {
    siteSection,
    siteSubSection: 'Create Organization',
    siteSubSubSection: 'Organization Feature Management',
    buttonClicks: {
      cancelBtn: {
        itemClicked: 'Cancel',
      },
      SaveBtn: {
        itemClicked: 'Save',
      },
    },
  },

  orgnSummary: {
    siteSection,
    siteSubSection: 'Organization Summary',
    buttonClicks: {
      editBtn: {
        itemClicked: 'Edit',
      },
      copyOrgBtn: {
        itemClicked: 'Copy Organization',
      },
      cancelBtn: {
        itemClicked: 'Cancel',
      },
      submitBtn: {
        itemClicked: 'Submit',
      },
    },
  },

  orgViewPage: {
    siteSection,
    siteSubSection: 'Organization View Page',
    buttonClicks: {
      viewAsUserBtn: {
        itemClicked: 'View as User',
      },
      editOrgDetailsBtn: {
        itemClicked: editOrgDetails,
      },
      editEnterpriseSupportBtn: {
        itemClicked: 'Edit Enterprise Support',
      },
      editFeatureManagementBtn: {
        itemClicked: 'Edit Feature Management',
      },
      editServicesBtn: {
        itemClicked: 'Edit Services',
      },
      editSystemIdentifiersBtn: {
        itemClicked: 'Edit System Identifiers',
      },
      editChannelUploadBtn: {
        itemClicked: 'Edit Channel Upload Settings',
      },
      serviceLink: {
        itemClicked: 'service link',
      },
      addUserBtn: {
        itemClicked: 'Add User',
      },
      editAccountTeamBtn: {
        itemClicked: 'Edit Account Team',
      },
      editOrgDetailsMenuBtn: {
        itemClicked: editOrgDetails,
      },
      deleteOrgMenuBtn: {
        itemClicked: 'Delete Organization',
      },
      deleteOrgModalDeleteBtn: {
        itemClicked: 'Delete',
      },
      deleteOrgModalCancelBtn: {
        itemClicked: 'Cancel',
      },
      deleteOrgModalCloseBtn: {
        itemClicked: 'Close',
      },
      backBtn: {
        itemClicked: 'Back',
      },
      moreOptions: {
        itemClicked: 'More Options',
      },
      overviewTabBtn: {
        itemClicked: 'Overview',
      },
      peopleTabBtn: {
        itemClicked: 'People',
      },
    },
  },

  orgEditDetails: {
    siteSection,
    siteSubSection: editOrgDetails,
    buttonClicks: {
      backBtn: {
        itemClicked: backToOrg,
      },
      saveBtn: {
        itemClicked: 'Save',
      },
      cancelBtn: {
        itemClicked: 'Cancel',
      },
      editBtn: {
        itemClicked: 'Edit',
      },
    },
    menuSelections: {
      parentOrgMenu: {
        itemClicked: 'Parent Organization',
      },
      orgTypeMenu: {
        itemClicked: 'Organization Type',
      },
    },
  },

  orgEditServices: {
    siteSection,
    siteSubSection: 'Edit Organization Services',
    buttonClicks: {
      backBtn: {
        itemClicked: backToOrg,
      },
      saveBtn: {
        itemClicked: 'Save',
      },
      cancelBtn: {
        itemClicked: 'Cancel',
      },
    },
  },

  orgEditEntSupport: {
    siteSection,
    siteSubSection: 'Edit Organization Enterprise Support',
    buttonClicks: {
      backBtn: {
        itemClicked: backToOrg,
      },
      saveBtn: {
        itemClicked: 'Save',
      },
      cancelBtn: {
        itemClicked: 'Cancel',
      },
    },
    menuSelections: {
      orgTechSupport: {
        itemClicked: 'Technical and Billing Support',
      },
      'organization-enoc': {
        itemClicked: 'Enterprise Network Operations Center (ENOC)',
      },
    },
  },

  orgEditFeatures: {
    siteSection,
    siteSubSection: 'Edit Organization Feature Management',
    buttonClicks: {
      backBtn: {
        itemClicked: backToOrg,
      },
      saveBtn: {
        itemClicked: 'Save',
      },
      cancelBtn: {
        itemClicked: 'Cancel',
      },
    },
  },

  orgEditAccTeam: {
    siteSection,
    siteSubSection: 'Edit Organization Account Team',
    buttonClicks: {
      backBtn: {
        itemClicked: backToOrg,
      },
      saveBtn: {
        itemClicked: 'Save',
      },
      cancelBtn: {
        itemClicked: 'Cancel',
      },
      addContactBtn: {
        itemClicked: 'Add Contact',
      },
      removeContactBtn: {
        itemClicked: 'Remove',
      },
      copyContactBtn: {
        itemClicked: 'Copy Contact',
      },
    },
    menuSelections: {
      contactTypeMenu: {
        itemClicked: 'Contact Type',
      },
    },
  },

  orgEditSysIdentifiers: {
    siteSection,
    siteSubSection: 'Edit Organization System Identifiers',
    buttonClicks: {
      viewAsUserBtn: {
        itemClicked: 'View as User',
      },
      backBtn: {
        itemClicked: backToOrg,
      },
      saveBtn: {
        itemClicked: 'Save',
      },
      continueBtn: {
        itemClicked: 'Continue',
      },
      cancelBtn: {
        itemClicked: 'Cancel',
      },
      editBtn: {
        itemClicked: 'Edit',
      },
      closeBtn: {
        itemClicked: 'Close',
      },
      removeSrcSysIdNumBtn: {
        itemClicked: 'Remove',
      },
      undoSrcSysIdDeleteBtn: {
        itemClicked: 'Undo',
      },
      addStgAccIdNumBtn: {
        itemClicked: 'Add ID Number',
      },
      removeStgAccIdNumBtn: {
        itemClicked: 'Remove',
      },
      setDefaultStgAccBtn: {
        itemClicked: 'Set as Default',
      },
      addSrcSysIdNumBtn: {
        itemClicked: 'Add ID Number',
      },
      addSourceSystemBtn: {
        itemClicked: 'Add Source System',
      },
      sourceSystemsLink: {
        itemClicked: 'Source Systems',
      },
    },
    menuSelections: {
      sourceSystemMenu: {
        itemClicked: 'Source System',
      },
    },
  },

  orgEditChannelUploadSettings: {
    siteSection,
    siteSubSection: 'Edit Organization Channel Upload Settings',
    buttonClicks: {
      backBtn: {
        itemClicked: backToOrg,
      },
      saveBtn: {
        itemClicked: 'Save',
      },
      cancelBtn: {
        itemClicked: 'Cancel',
      },
      addChannelBtn: {
        itemClicked: 'Add Channel',
      },
      removeChannelBtn: {
        itemClicked: 'Remove Channel',
      },
      deleteChannelUploadModalDeleteBtn: {
        itemClicked: 'Delete',
      },
      deleteChannelUploadModalCloseBtn: {
        itemClicked: 'Close',
      },
    },
  },
};
